
  import { defineComponent, onMounted, ref } from 'vue'
  import { useRoute, useRouter } from 'vue-router'
  import { useToken } from '@/hooks/storage'

  export default defineComponent({
    setup() {
      onMounted(() => {
        if (!useToken().get()) { 
          window.location.href=(window as any).VUE_APP_TEACHER_CAS_URL
        }
        const route = useRoute()
      })
      const token = ref('')
      return { token }
    }
  })
